export default "__VITE_ASSET__g5fcR4IU__"